import { render, staticRenderFns } from "./PersonalPaymentsPanel.vue?vue&type=template&id=489a18c8&scoped=true"
import script from "./PersonalPaymentsPanel.vue?vue&type=script&lang=js"
export * from "./PersonalPaymentsPanel.vue?vue&type=script&lang=js"
import style0 from "./PersonalPaymentsPanel.vue?vue&type=style&index=0&id=489a18c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489a18c8",
  null
  
)

export default component.exports